<template>
  <div class="desktop-side-navigation" v-if="showSideNavigation">
    <div v-if="userInfo && userInfo.avatar && userInfo.user_type" style="display: flex;justify-content:centet; flex-direction: column;">
      <!-- <ResilienceDoughnut msize="medium" mid="nav-res" :isHideLegend="true" :profile="userInfo" /> -->
      <img :src="userInfo.avatar" :class="isAllowPoints ? 'points-border' : ''" class="user-avatar" @click="onviewprofile(userInfo.id)" />
      <div style="display: flex; flex-direction: column; justify-content: space-evenly">
        <h2 align="center">
          <span
            v-if="userInfo && userInfo.user_type != 'guest'"
            @click="onviewprofile(userInfo.id)"
            class="truncate pointer"
          >{{userInfo.display_name}}</span>
          <span v-else>Guest</span>
        </h2>
        <p align="center">
        <a v-if="userInfo && userInfo.user_type && userInfo.user_type !== 'guest'"><small
          class="pointer"
          @click="redirect('/signout')"
        >Logout</small></a>
        <small v-else class="pointer">
          <span @click="redirect('/login')">Login</span> &middot; 
          <span @click="onJoin()">Register</span></small>
        </p>
      </div>
    </div>
    <div style="padding: 20px 15px 0;">
      <div class="desktop-side-menu-item" @click="redirect('/home')">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="toolbar-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          :style="{
            stroke : activeTab == 'home' ? 'var(--bottom-icon-highlight-color)' : 'var(--bottom-icon-color)'
          }"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
        <span
          :style="{
            color : activeTab == 'home' ? 'var(--bottom-icon-highlight-color)' : 'var(--bottom-icon-color)'
          }"
        >Home</span>
      </div>
      <div class="desktop-side-menu-item" @click="redirect('/groups')">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          :style="{
            stroke : activeTab == 'discover' ? 'var(--bottom-icon-highlight-color)' : 'var(--bottom-icon-color)'
          }"
          stroke="#657180"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-compass"
        >
          <circle cx="12" cy="12" r="10" />
          <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
        </svg>
        <span
          :style="{
            color : activeTab == 'discover' ? 'var(--bottom-icon-highlight-color)' : 'var(--bottom-icon-color)'
          }"
        >Connect</span>
      </div>
      <div class="desktop-side-menu-item" @click="redirect('/library')">
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="18px"
          height="18px"
          viewBox="0 0 440.000000 531.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,531.000000) scale(0.100000,-0.100000)"
            :fill="activeTab == 'courses' ? 'var(--bottom-icon-highlight-color)' : 'var(--bottom-icon-color)'"
            stroke="none"
          >
            <path
              d="M3210 5286 c-41 -13 -130 -39 -197 -59 -519 -154 -1146 -384 -1426
                -524 -334 -166 -559 -407 -629 -671 -21 -81 -23 -104 -21 -337 1 -137 8 -308
                16 -380 l14 -130 -107 -165 c-414 -639 -669 -1090 -779 -1378 -43 -113 -81
                -275 -81 -347 0 -80 41 -231 90 -330 97 -200 353 -498 629 -735 35 -30 79 -75
                97 -99 52 -67 100 -98 182 -117 70 -16 76 -15 150 4 42 11 142 44 222 72 80
                29 192 69 250 90 157 56 384 140 580 213 757 284 1142 518 1281 779 20 38 69
                219 84 313 30 186 30 285 -1 610 -4 42 -16 102 -60 316 -5 21 13 52 97 170
                323 452 592 907 702 1184 40 101 97 321 97 375 0 51 -45 228 -75 296 -90 204
                -317 455 -599 662 -65 48 -144 108 -175 134 -45 38 -70 51 -123 63 -89 20
                -128 18 -218 -9z m140 -283 c0 -5 -14 -33 -31 -63 -17 -30 -42 -84 -55 -119
                -13 -36 -28 -69 -33 -75 -13 -16 -128 -327 -150 -404 -11 -37 -36 -123 -56
                -192 -20 -69 -38 -141 -40 -160 -2 -19 -14 -93 -26 -165 -33 -189 -33 -475 0
                -625 13 -58 25 -114 27 -125 2 -11 19 -60 37 -110 124 -332 241 -812 248
                -1015 13 -351 -4 -514 -69 -650 -64 -135 -401 -340 -872 -530 -30 -12 -74 -31
                -97 -41 -23 -11 -47 -19 -52 -19 -6 0 -61 -20 -122 -45 -61 -25 -117 -45 -124
                -45 -7 0 -33 -9 -59 -20 -25 -12 -97 -39 -158 -61 -62 -21 -122 -44 -133 -49
                -11 -5 -58 -23 -105 -38 -110 -38 -267 -93 -352 -126 l-68 -25 31 52 c16 29
                38 70 49 92 43 94 100 224 100 229 0 3 21 58 46 122 25 65 54 149 64 188 11
                39 35 130 54 201 19 72 37 159 40 194 4 35 12 96 18 135 17 99 17 472 0 561
                -8 39 -15 84 -17 101 -2 16 -23 127 -48 245 -41 194 -101 559 -127 764 -21
                172 -35 704 -20 775 3 14 23 59 45 99 54 103 183 230 310 307 54 33 301 154
                314 154 5 0 37 13 72 29 35 16 116 48 179 71 63 24 120 46 125 50 6 4 37 15
                70 25 33 9 79 25 102 36 23 10 66 25 95 33 29 8 98 30 153 48 185 64 602 196
                623 197 6 1 12 -2 12 -6z m337 -262 c189 -166 314 -320 371 -453 39 -93 37
                -200 -6 -328 -75 -226 -312 -647 -585 -1043 l-74 -107 -15 42 c-126 354 -140
                417 -141 638 -1 138 4 206 22 320 26 163 80 376 129 510 11 30 34 91 50 135
                16 44 43 110 60 147 18 37 32 70 32 74 0 16 62 134 70 134 6 0 45 -31 87 -69z
                m-2637 -2101 c6 -47 29 -166 50 -265 68 -311 75 -370 74 -585 -1 -300 -45
                -554 -139 -805 -19 -49 -37 -101 -41 -115 -3 -14 -29 -74 -56 -135 -27 -60
                -59 -131 -70 -157 -12 -27 -25 -48 -28 -48 -4 0 -70 64 -146 143 -232 238
                -361 431 -386 577 -10 57 -8 75 11 147 56 215 245 578 594 1141 66 106 121
                192 122 190 2 -2 9 -41 15 -88z"
            />
          </g>
        </svg>
        <span
          :style="{
            color : activeTab == 'courses' ? 'var(--bottom-icon-highlight-color)' : 'var(--bottom-icon-color)'
          }"
        >Discover</span>
      </div>
      <div class="desktop-side-menu-item" @click="redirect('/profile/' + userInfo.id)">
        <svg
          class="toolbar-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          :style="{
            stroke : activeTab == 'me' ? 'var(--bottom-icon-highlight-color)' : 'var(--bottom-icon-color)'
          }"
          viewBox="0 0 24 24"
        >
          <path
            d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            class="s"
          />
          <circle
            cx="12"
            cy="7"
            r="4"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
          />
        </svg>
        <span
          :style="{
            color : activeTab == 'me' ? 'var(--bottom-icon-highlight-color)' : 'var(--bottom-icon-color)'
          }"
        >Me</span>
      </div>
      <div class="desktop-side-menu-item" @click="openMore">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none"
          stroke="#657180"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-compass"
          stroke-width="0">
            <path fill="var(--bottom-icon-color)" d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
        </svg>
        <span>More</span>
      </div>
    </div>
    <Modal
        title="More"
        :transfer="true"
        :footer-hide="true"
        @on-cancel="moreModal = false"
        v-model="moreModal"
        class="do-action-menu-cls"
        :styles="{top: '20px', width: '320px', padding: 0}">
        <div style="margin: 15px 10px;" v-if="(sortedMenu || sortedMenu.length > 0)">
          <div
            v-for="(item, i) in sortedMenu"
            :key="i"
            class="desktop-side-menu-item">
            <div 
              v-if="!isLink(item)"
              @click="onSelectMenu(item)">
              <img class="do-action-img" :src="postPreviewImage(item)" alt />
              <span>{{item.title}}</span>
            </div>
            <a style="color: #657180" :href="link(item)" :target="link(item) != '#' ? '_blank' : '_self'" v-else>
              <img class="do-action-img" :src="postPreviewImage(item)" alt />
              <span>{{item.title}}</span>
            </a>
          </div>
        </div>
        <div
          v-if="isMenuItemLoading"
          style="display: flex; justify-content: center; padding-right: 15px; margin: 20px;">
          <Icon type="load-c" size="18" class="spinner-load"></Icon>
        </div>
    </Modal>
    <!-- <div style="margin: 10px 15px;" v-if="(sortedMenu || sortedMenu.length > 0)">
      <div
        v-for="(item, i) in sortedMenu"
        @click="onSelectMenu(item)"
        :key="i"
        class="desktop-side-menu-item"
      >
        <img class="do-action-img" :src="postPreviewImage(item)" alt />
        <span>{{item.title}}</span>
      </div>
    </div>
    <div
      v-if="isMenuItemLoading"
      style="display: flex; justify-content: center; padding-right: 15px; margin: 20px;"
    >
      <Icon type="load-c" size="18" class="spinner-load"></Icon>
    </div> -->
  </div>
</template>

<script>
import _ from "lodash";
import Utils from "@/utils.js";
import VueCookie from "vue-cookie";
import ResilienceDoughnut from "@/components/ResilienceDoughnut";
import { mapGetters } from "vuex"

export default {
  name: "SideNavigationComponent",
  data() {
    return {
      moreModal: false
    }
  },
  components: {
    ResilienceDoughnut
  },
  computed: {
    ...mapGetters("user", ["isAllowPoints", "isBroadcast", "brandInfo"]),
    userInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    menuItems() {
      let selections = this.$store.state.menuItems;
      if (this.isBroadcast) {
        selections.pages.forEach( (element, x) => {
          if( element.type === "add_ons" && element.data.add_on_slug == "post_update" )
            selections.pages.splice(x, 1);
        });
      }
      return selections;
    },
    isMenuItemLoading() {
      return this.$store.state.isMenuItemLoading;
    },
    sortedMenu() {
      return _.orderBy(this.menuItems.pages, "order");
    },
    activeTab() {
      var routeName = this.$route.name;
      if (routeName == "HomePage" || routeName == "HomePage-Brand")
        return "home";
      else if (
        routeName == "ProfileViewPage" ||
        routeName == "ProfileViewPage-Brand"
      )
        return "me";
      else if (routeName == "Library" || routeName == "Library-Brand")
        return "courses";
      else if (routeName == "Groups" || routeName == "Groups-Brand")
        return "discover";
    },
    showSideNavigation() {
      var routeName = this.$route.name;

      if (routeName == "LoginComponent" || routeName == "LoginComponent-Brand")
        return false;
      else if (
        routeName == "VerifyMobileComponent" ||
        routeName == "VerifyMobileComponent-Brand"
      )
        return false;
      else if (
        routeName == "StepThreeMobileComponent" ||
        routeName == "StepThreeMobileComponent-Brand"
      )
        return false;
      else if (
        routeName == "PasswordResetComponent" ||
        routeName == "PasswordResetComponent-Brand"
      )
        return false;
      else if (
        routeName == "Welcome" ||
        routeName == "Welcome-Brand"
      )
        return false;
      else return true;
    }
  },
  methods: {
    openMore() {
      this.moreModal = true
      this.$store.dispatch('getActionMenu', null, {root:1});
    },
    onJoin() {
      if ( VueCookie.get('os_type') === "ios" && !VueCookie.get('ios_app_version') ) {
        window.webkit.messageHandlers.onNativeCalled.postMessage({
          name: 'authRegister',
          params: {}
        })
        return false;
      }

      this.$router.replace({path: `/${this.route.params.brandSlug}/login?type=signup`})
    },
    redirect(url) {
      if( url == '/signout') {
        this.$store.dispatch('base/signout', null, {root: 1})
          .then(() => {
            this.$router.replace(`/${this.$route.params.brandSlug}/login`);
          })
      } else {
        this.$router.push(url);
      }
    },
    loadMenuItems() {
      this.$store.dispatch("getActionMenu", null, { root: 1 });
    },
    onviewprofile(v) {
      this.$store.commit("setCurrentTab", 1, { root: 1 });
      this.$router.push(v ? "/profile/" + v : "/profile");
    },
    postPreviewImage(act) {
      return Utils.getDisplayImage("activity", act, "medium");
    },
    onSelectMenu(i) {
      console.log("onSelectMenu...", i);
      if (
        i.data &&
        i.type === "group_page" &&
        "careplan_id" in i.data &&
        i.data.careplan_id
      ) {
        console.log("push to resources", i.data.careplan_id);
        this.$router.push("/resources/" + i.data.careplan_id);
        return false;
      }

      console.log("event emitted...", i);
      this.moreModal = false;

      if (this.isLink(i))
        return false
      else
        BroadcastEvent.$emit("ADDONMENU", i);
    },
    isLink(item) {
      let hasGenericId = this.userInfo.generic_id;
      let hasGenericIdUrl = false;
      let isLinkType =
        item.type == "attachment" && item.data.attachment_type == "link";

      if (isLinkType)
        hasGenericIdUrl = item.data.url.includes("{" + this.brandInfo.generic_id.slug + "}")

      if (isLinkType && !hasGenericIdUrl) return true;
      else if (isLinkType && hasGenericIdUrl && !hasGenericId) return false;
      else return isLinkType;
    },
    link(v) {
       switch (v.data.attachment_type) {
        case "link":
            let url = v.data.url;
            if (v.data.url.includes("{userId}")) {
              url = url.replace(/{userId}/g, this.userInfo.id);
            }

            if (this.brandInfo.generic_id) {
              if (
                this.brandInfo.generic_id.slug &&
                v.data.url.includes(`{${this.brandInfo.generic_id.slug}}`)
              )
                if (this.userInfo.generic_id) {
                  let rgx = `{${this.brandInfo.generic_id.slug}}`;
                  url = url.replace(rgx, this.userInfo.generic_id);
                } else
                  url = url.replace(
                    /[{generic_id}|{genericId}]/g,
                    this.userInfo.generic_id
                  );
            } else {
              if (
                v.data.url.includes("{generic_id}") ||
                v.data.url.includes("{genericId}")
              ) {
                if (this.userInfo.generic_id) {
                  url = url.replace(
                    /[{generic_id}|{genericId}]/g,
                    this.userInfo.generic_id
                  );
                }
              }
            }

            if (v.data.url.includes("{studentId}")) {
              if (this.userInfo.generic_id) {
                url = url.replace(/{studentId}/g, this.userInfo.generic_id);
              }
            }
            if (v.data.url.includes("{appName}")) {
              url = url.replace(/{appName}/g, this.brandInfo.title);
            }
            if (v.data.url.includes("{generic_email}")) {
              url = url.replace(/{generic_email}/g, this.userInfo.generic_email);
            }
            if (v.data.url.includes("{generic_mobile_number}")) {
              url = url.replace(/{generic_mobile_number}/g, this.userInfo.generic_mobile_number);
            }
            return url
          break;
      }
    },
  }
};
</script>

<style>
.do-action-menu-cls .ivu-modal-body {
  padding: 0 !important;
}
</style>

<style scoped lang="scss">
.user-avatar {
  width: 130px;
  height: 130px;
  border-radius: 130px;
  border-width: 15px;
  margin: 0 auto;
  cursor: pointer;
}
.points-border {
  border-color: #1E89A7 #4E1C9B #83CA27 #F19B2F;
  border-style: solid;
}
@media (max-width: 767px) {
  .desktop-side-navigation {
    display: none;
  }
}

@media (min-width: 1025px) {
  .desktop-side-navigation {
    width: 20% !important;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .desktop-side-navigation {
    width: 30% !important;
  }
}
.desktop-side-navigation {
  position: fixed;
  width: 20%;
  padding: 20px;
}

.desktop-side-menu-item {
  display: flex;
  align-items: center;
  margin: 10px;
  cursor: pointer;
  align-items: flex-start;
  svg,
  .do-action-img {
    object-fit: contain;
    height: 22px !important;
    width: 22px !important;
    margin-right: 32px;
    stroke: var(--bottom-icon-color);
  }
  span {
    line-height: 20px;
    color: var(--bottom-icon-color);
  }
}
</style>
